import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRightIcon } from 'lucide-react';
import { evidence, studyDesign } from '../../../data/snak';
const EASE = [0.23, 1, 0.32, 1] as const;
interface EvidencePageProps {
  onOpenStudy: () => void;
}
export function EvidencePage({
  onOpenStudy
}: EvidencePageProps) {
  const facts = studyDesign.rows.slice(0, 3);
  return <div className="flex flex-1 flex-col px-10 py-7" data-id="element-172" data-mp="zqhm1x3uwxka">
      <motion.h2 initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.28,
      ease: EASE
    }} className="max-w-3xl font-display text-[33px] font-semibold leading-[1.06] tracking-tight text-navy" data-id="element-173" data-mp="zpprmplzx5vl">
        {evidence.headline}
      </motion.h2>

      <div className="mt-7 grid gap-5 md:grid-cols-2" data-id="element-174" data-mp="1dphab3ngjafx">
        <motion.section initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.26,
        delay: 0.08,
        ease: EASE
      }} className="rounded-2xl border-l-2 border-mint bg-sky/40 px-7 py-6" data-id="element-175" data-mp="3aj2d65v2gfu2">
          <p className="font-display text-[11px] uppercase tracking-micro text-navy" data-id="element-176" data-mp="2gkvy5gyssxej">
            {evidence.shows.label}
          </p>
          <p className="mt-4 text-[17px] leading-snug text-navy" data-id="element-177" data-mp="26sq7qbo72o1g">{evidence.shows.copy}</p>
        </motion.section>

        <motion.section initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.26,
        delay: 0.14,
        ease: EASE
      }} className="rounded-2xl bg-navy px-7 py-6" data-id="element-178" data-mp="22so4vz6q3okl">
          <p className="font-display text-[11px] uppercase tracking-micro text-mint" data-id="element-179" data-mp="2ugpwx75uy6dx">
            {evidence.doesNot.label}
          </p>
          <p className="mt-4 text-[17px] leading-snug text-paper" data-id="element-180" data-mp="2lie5x412x6ky">{evidence.doesNot.copy}</p>
        </motion.section>
      </div>

      <motion.p initial={{
      opacity: 0,
      y: 8
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.26,
      delay: 0.2,
      ease: EASE
    }} className="mt-6 max-w-3xl text-[13.5px] leading-relaxed text-mut" data-id="element-181" data-mp="1f33mbhehetbu">
        {evidence.support}
      </motion.p>

      <motion.div initial={{
      opacity: 0,
      y: 8
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.26,
      delay: 0.26,
      ease: EASE
    }} className="mt-auto flex items-end justify-between gap-8 border-t border-line pt-6" data-id="element-182" data-mp="1gjheqb2ma2gd">
        <dl className="grid flex-1 grid-cols-3 gap-8" data-id="element-183" data-mp="16mw85lay8jaf">
          {facts.map((fact, i) => <div key={fact.label} className="flex gap-3" data-id="element-184" data-mp="srtta8o4jjlh" data-mpi={i}>
              <span className="font-display text-[10px] font-bold tabular-nums text-blue" data-id="element-185" data-mp="xl538io8gghm">
                {String(i + 1).padStart(2, '0')}
              </span>
              <div data-id="element-186" data-mp="nuadv5fox0ry">
                <dt className="text-[9px] uppercase tracking-micro text-mut" data-id="element-187" data-mp="ntscjue67wd6">{fact.label}</dt>
                <dd className="mt-1.5 text-[13px] leading-snug text-navy" data-id="element-188" data-mp="9uitmmykyo5i">{fact.value}</dd>
              </div>
            </div>)}
        </dl>

        <button type="button" onClick={onOpenStudy} className="flex shrink-0 items-center gap-2 rounded-full border border-line px-4 py-2 text-[12px] font-medium text-navy transition-colors duration-150 hover:border-blue hover:bg-sky/40 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue" data-id="element-189" data-mp="evyeadwuisnd">
          Methodology and limitations
          <ArrowUpRightIcon className="h-3.5 w-3.5 text-blue" aria-hidden="true" data-id="element-190" data-mp="5lpjp46mf82" />
        </button>
      </motion.div>
    </div>;
}